import {
  TerminalAppearanceSettings,
  TerminalChildrenModeButtonShape,
  TerminalChildrenModeDecorationType,
  TerminalChildrenModeSettings,
} from '../../../types/Admin/TerminalAppearanceTypes';
import { DEFAULT_CHILDREN_PRESET_THEME_ID } from '../../Terminal/childrenModeThemes';

type NormalizeChildrenModeParams = {
  childrenMode?: TerminalChildrenModeSettings | null;
  activeChildrenBackgroundId: number | null;
  defaultBackgroundFitMode: NonNullable<TerminalAppearanceSettings['backgroundFitMode']>;
};

export const buildDefaultChildrenModeSettings = (
  defaultBackgroundFitMode: NonNullable<TerminalAppearanceSettings['backgroundFitMode']>,
): TerminalChildrenModeSettings => ({
  activateChildrenMode: false,
  showToggleButton: false,
  decorationType: 'THEME',
  presetThemeId: DEFAULT_CHILDREN_PRESET_THEME_ID,
  activeBackgroundId: null,
  backgroundFitMode: defaultBackgroundFitMode,
  backgroundOffsetByHeader: false,
  buttonShape: 'RECTANGLE',
  showStandardModeIcons: false,
  hideIcons: false,
  switchByAgeEnabled: false,
  ageThreshold: 14,
});

export const normalizeChildrenModeSettings = ({
  childrenMode,
  activeChildrenBackgroundId,
  defaultBackgroundFitMode,
}: NormalizeChildrenModeParams): TerminalChildrenModeSettings => {
  const defaults = buildDefaultChildrenModeSettings(defaultBackgroundFitMode);

  return {
    activateChildrenMode: childrenMode?.activateChildrenMode ?? defaults.activateChildrenMode,
    showToggleButton: childrenMode?.showToggleButton ?? defaults.showToggleButton,
    decorationType: (childrenMode?.decorationType ?? defaults.decorationType) as TerminalChildrenModeDecorationType,
    presetThemeId: childrenMode?.presetThemeId ?? defaults.presetThemeId,
    activeBackgroundId: activeChildrenBackgroundId,
    backgroundFitMode: childrenMode?.backgroundFitMode ?? defaultBackgroundFitMode,
    backgroundOffsetByHeader: childrenMode?.backgroundOffsetByHeader ?? false,
    buttonShape: (childrenMode?.buttonShape ?? 'RECTANGLE') as TerminalChildrenModeButtonShape,
    showStandardModeIcons: childrenMode?.showStandardModeIcons ?? false,
    hideIcons: childrenMode?.hideIcons ?? false,
    switchByAgeEnabled: childrenMode?.switchByAgeEnabled ?? false,
    ageThreshold: Number.isFinite(childrenMode?.ageThreshold)
      ? Math.min(99, Math.max(1, childrenMode!.ageThreshold!))
      : 14,
  };
};
